import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export default api;

export const errMsg = (error, fallback = "Something went wrong") =>
  error?.response?.data?.detail || error?.message || fallback;
